import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

/**
 * Stage navigation for OC request workspace (session or lab magic link).
 * No internal-approval step — tech submit goes to client or admin.
 *
 * @param {Object} props
 * @param {string} props.basePath - e.g. /organoid-requests/9 or /organoid-requests/access/tok
 * @param {string} props.active - detail | data-review | technical-review | preparation
 */
const OcStageNav = ({ basePath, active }) => (
  <Nav variant="pills" className="oc-stage-nav mb-3 flex-wrap gap-1">
    <Nav.Link as={Link} to={basePath} active={active === 'detail'}>
      Detail
    </Nav.Link>
    <Nav.Link
      as={Link}
      to={`${basePath}/data-review`}
      active={active === 'data-review'}
    >
      Data review
    </Nav.Link>
    <Nav.Link
      as={Link}
      to={`${basePath}/technical-review`}
      active={active === 'technical-review'}
    >
      Technical review
    </Nav.Link>
    <Nav.Link
      as={Link}
      to={`${basePath}/preparation`}
      active={active === 'preparation'}
    >
      Preparation
    </Nav.Link>
  </Nav>
);

export default OcStageNav;
